// extracted by mini-css-extract-plugin
export default {"NavLink":"NavLink_NavLink__ukGqZ","Icon":"NavLink_Icon__XOI7n"};